import React from 'react';

const ROADMAP = [
  {
    quarter: 'Q2 2026',
    title: 'Foundation',
    status: 'completed',
    items: [
      { text: 'Token launch on TON', done: true },
      { text: 'Mini App with 7 games', done: true },
      { text: 'Presale Stage 1 (50% off)', done: true },
      { text: 'VIP system + multipliers', done: true },
    ],
  },
  {
    quarter: 'Q3 2026',
    title: 'Growth',
    status: 'current',
    items: [
      { text: 'Presale Stages 2-5', done: false },
      { text: 'CoinGecko listing', done: false },
      { text: 'Smart contract audit', done: false },
      { text: 'Sound effects & animations', done: false },
    ],
  },
  {
    quarter: 'Q4 2026',
    title: 'Expansion',
    status: 'upcoming',
    items: [
      { text: 'Presale Stages 6-10', done: false },
      { text: 'CoinMarketCap listing', done: false },
      { text: 'NFT collection (1000 pcs)', done: false },
      { text: 'Weekly tournaments', done: false },
    ],
  },
  {
    quarter: '2027',
    title: 'Evolution',
    status: 'upcoming',
    items: [
      { text: 'DEX listing (STON.fi)', done: false },
      { text: 'CEX listing (MEXC/Gate)', done: false },
      { text: 'DAO governance', done: false },
      { text: 'Cross-chain bridge', done: false },
    ],
  },
];

const statusColors = {
  completed: { bg: 'rgba(16,185,129,0.15)', border: 'rgba(16,185,129,0.4)', badge: '#10B981', text: '✅ Completed' },
  current: { bg: 'rgba(245,158,11,0.15)', border: 'rgba(245,158,11,0.4)', badge: '#F59E0B', text: '🔄 In Progress' },
  upcoming: { bg: 'rgba(139,92,246,0.1)', border: 'rgba(139,92,246,0.3)', badge: '#8B5CF6', text: '📋 Upcoming' },
};

export const RoadmapPage = () => {
  return (
    <div style={{ padding: '0 16px 100px' }}>
      {/* Header */}
      <div className="page-header">
        <div className="page-header-icon" style={{ background: 'linear-gradient(135deg, #8B5CF6, #6366F1)' }}>🗺️</div>
        <div>
          <div className="page-title">Roadmap</div>
          <div className="page-subtitle">Where we're going</div>
        </div>
      </div>

      {/* Timeline */}
      <div style={{ position: 'relative' }}>
        {/* Vertical line */}
        <div style={{
          position: 'absolute',
          left: 20,
          top: 20,
          bottom: 20,
          width: 2,
          background: 'linear-gradient(180deg, #10B981, #F59E0B, #8B5CF6)',
          borderRadius: 1,
        }} />

        {ROADMAP.map((phase, i) => {
          const colors = statusColors[phase.status];
          return (
            <div key={i} style={{
              display: 'flex',
              gap: 16,
              marginBottom: 20,
              position: 'relative',
            }}>
              {/* Timeline dot */}
              <div style={{
                width: 42,
                height: 42,
                borderRadius: '50%',
                background: colors.bg,
                border: `2px solid ${colors.border}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 18,
                flexShrink: 0,
                zIndex: 1,
              }}>
                {phase.status === 'completed' ? '✅' : phase.status === 'current' ? '🔄' : '📋'}
              </div>

              {/* Content */}
              <div style={{
                flex: 1,
                background: colors.bg,
                border: `1px solid ${colors.border}`,
                borderRadius: 16,
                padding: 16,
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div>
                    <div style={{ fontSize: 12, color: colors.badge, fontWeight: 700, marginBottom: 4 }}>
                      {phase.quarter}
                    </div>
                    <div style={{ fontSize: 18, fontWeight: 800, color: '#fff' }}>
                      {phase.title}
                    </div>
                  </div>
                  <div style={{
                    padding: '4px 10px',
                    borderRadius: 20,
                    background: `${colors.badge}20`,
                    border: `1px solid ${colors.badge}40`,
                    fontSize: 10,
                    fontWeight: 700,
                    color: colors.badge,
                  }}>
                    {colors.text}
                  </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {phase.items.map((item, j) => (
                    <div key={j} style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      padding: '8px 10px',
                      background: 'rgba(0,0,0,0.2)',
                      borderRadius: 8,
                    }}>
                      <span style={{ fontSize: 14 }}>
                        {item.done ? '✅' : '⬜'}
                      </span>
                      <span style={{
                        fontSize: 13,
                        color: item.done ? '#10B981' : 'var(--text-secondary)',
                        textDecoration: item.done ? 'none' : 'none',
                      }}>
                        {item.text}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Progress summary */}
      <div style={{
        marginTop: 16,
        padding: 16,
        background: 'var(--bg-card)',
        borderRadius: 14,
        border: '1px solid var(--border-color)',
      }}>
        <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 12, color: '#fff' }}>
          📊 Overall Progress
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <div style={{ flex: 1, textAlign: 'center', padding: 12, background: 'rgba(16,185,129,0.1)', borderRadius: 10 }}>
            <div style={{ fontSize: 24, fontWeight: 900, color: '#10B981' }}>4</div>
            <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>Completed</div>
          </div>
          <div style={{ flex: 1, textAlign: 'center', padding: 12, background: 'rgba(245,158,11,0.1)', borderRadius: 10 }}>
            <div style={{ fontSize: 24, fontWeight: 900, color: '#F59E0B' }}>4</div>
            <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>In Progress</div>
          </div>
          <div style={{ flex: 1, textAlign: 'center', padding: 12, background: 'rgba(139,92,246,0.1)', borderRadius: 10 }}>
            <div style={{ fontSize: 24, fontWeight: 900, color: '#8B5CF6' }}>8</div>
            <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>Upcoming</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoadmapPage;
